import { render, staticRenderFns } from "./BotaoWhatsapp.vue?vue&type=template&id=7ffca5c4"
import script from "./BotaoWhatsapp.vue?vue&type=script&lang=js"
export * from "./BotaoWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffca5c4')) {
      api.createRecord('7ffca5c4', component.options)
    } else {
      api.reload('7ffca5c4', component.options)
    }
    module.hot.accept("./BotaoWhatsapp.vue?vue&type=template&id=7ffca5c4", function () {
      api.rerender('7ffca5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/botao-whatsapp/components/BotaoWhatsapp.vue"
export default component.exports